// extracted by mini-css-extract-plugin
export var bIcon = "CheckIconColumn-module--bIcon--8a642";
export var root = "CheckIconColumn-module--root--241c8";
export var wrapperC = "CheckIconColumn-module--wrapperC--36bca";